import { Route, Switch } from 'react-router-dom';
import { ROUTE } from 'shared/constants/routes_old';
import AppInfoWrapper from 'shared/components/AppInfoWrapper';
import ApplyResetPassword from './apply-reset-password';
import Login, { Register } from './login';
import RegisterConfirmed from './register-confirmed';
import RegisterSuccess from './register-success';
import ResetPassword from './reset-password';
import OAuthPage from './oauth';

export default function LoginLayout() {
	return (
		<Switch>
			{/* {!getLocalHelpScreens()[KEY_GREETINGS] && <Route component={HelpGreetings} />} */}
			<AppInfoWrapper>
				<Switch>
					<Route path={ROUTE.register} exact component={Register} />
					<Route path={ROUTE.registerSuccess} component={RegisterSuccess} />
					<Route path={ROUTE.registerConfirmed} component={RegisterConfirmed} />
					<Route path={ROUTE.resetPassword} component={ResetPassword} />
					<Route path={ROUTE.applyResetPassword} component={ApplyResetPassword} />
					<Route path={ROUTE.oauth} component={OAuthPage} />

					<Route component={Login} />
				</Switch>
			</AppInfoWrapper>
		</Switch>
	);
}
